export default variants => {
  const uniqueVariantColourWayIds = Array.from(
    new Set(variants.map(({ colourWayId }) => colourWayId))
  );

  return uniqueVariantColourWayIds.map(uniqueColourWayId => {
    const variantsWithColourWayId = variants.filter(
      ({ colourWayId }) => colourWayId === uniqueColourWayId
    );

    const isColourInStock = variantsWithColourWayId.some(
      ({ isVariantInStock }) => isVariantInStock
    );

    return {
      ...variantsWithColourWayId[0],
      isColourInStock
    };
  });
};
